// @flow

export const VALID = undefined; // undefined represents no error, so valid!
export const SERVER_ERROR_MESSAGE = 'Server error';
